import shareEvents from './shareEvents';
import { SegmentData, ShareData } from '../types/share';

function webShareSupported(shareData: ShareData) {
  return (navigator && navigator.share) !== undefined && navigator.canShare(shareData);
}
async function baseShare(shareData: ShareData, segmentData: SegmentData) {
  try {
    await navigator.share(shareData);
    shareEvents.trackShareSucceeded(segmentData);
  } catch (error) {
    if ((error instanceof DOMException) && ['AbortError', 'NotAllowedError'].includes(error.name)) {
      shareEvents.trackShareCanceled(segmentData);
    } else {
      shareEvents.trackShareFailed(segmentData);
    }
  }
}
async function shareLink(link: string, text: string, segmentData: SegmentData) {
  const dataToShare = { url: link, text };
  if (webShareSupported(dataToShare)) {
    const enrichedSegmentData = { ...segmentData, isWebShareSupported: false };
    await baseShare(dataToShare, enrichedSegmentData);
  } else {
    const enrichedSegmentData = { ...segmentData, isWebShareSupported: true };
    shareEvents.trackShareSucceeded(enrichedSegmentData);
    const textWithLink = text ? encodeURIComponent(`${text}\n${link}`) : link;
    window.open(`https://api.whatsapp.com/send?text=${textWithLink}`, '_blank');
  }
}

export default {
  shareLink,
};
